'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var cheerio = require('cheerio');
var HtmlTableToJson = /*#__PURE__*/function () {
  function HtmlTableToJson(html) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, HtmlTableToJson);
    if (typeof html !== 'string') {
      throw new TypeError('html input must be a string');
    }
    this.html = html;
    this.opts = opts;
    this._$ = cheerio.load(this.html);
    this._results = [];
    this._headers = [];
    this._count = null;
    this._firstRowUsedAsHeaders = [];
    this._process();
  }
  _createClass(HtmlTableToJson, [{
    key: "count",
    get: function get() {
      return Number.isInteger(this._count) ? this._count : this._count = this._$('table').get().length;
    }
  }, {
    key: "results",
    get: function get() {
      return this.opts.values === true ? this._results.map(function (result) {
        return result.map(Object.values);
      }) : this._results;
    }
  }, {
    key: "headers",
    get: function get() {
      return this._headers;
    }
  }, {
    key: "_process",
    value: function _process() {
      var _this = this;
      if (this._results.length) {
        return this._results;
      }
      this._$('table').each(function (i, element) {
        return _this._processTable(i, element);
      });
      return this._results;
    }
  }, {
    key: "_processTable",
    value: function _processTable(tableIndex, table) {
      var _this2 = this;
      this._results[tableIndex] = [];
      this._buildHeaders(tableIndex, table);
      this._$(table).find('tr').each(function (i, element) {
        return _this2._processRow(tableIndex, i, element);
      });
      this._pruneEmptyRows(tableIndex);
    }
  }, {
    key: "_processRow",
    value: function _processRow(tableIndex, index, row) {
      var _this3 = this;
      if (index === 0 && this._firstRowUsedAsHeaders[tableIndex] === true) return;
      this._results[tableIndex][index] = {};
      this._$(row).find('td').each(function (i, cell) {
        _this3._results[tableIndex][index][_this3._headers[tableIndex][i] || i + 1] = _this3._$(cell).text().trim();
      });
    }
  }, {
    key: "_buildHeaders",
    value: function _buildHeaders(index, table) {
      var _this4 = this;
      this._headers[index] = [];
      this._$(table).find('tr').each(function (i, row) {
        _this4._$(row).find('th').each(function (j, cell) {
          _this4._headers[index][j] = _this4._$(cell).text().trim();
        });
      });
      if (this._headers[index].length) return;
      this._firstRowUsedAsHeaders[index] = true;
      this._$(table).find('tr').first().find('td').each(function (j, cell) {
        _this4._headers[index][j] = _this4._$(cell).text().trim();
      });
    }
  }, {
    key: "_pruneEmptyRows",
    value: function _pruneEmptyRows(tableIndex) {
      this._results[tableIndex] = this._results[tableIndex].filter(function (t) {
        return Object.keys(t).length;
      });
    }
  }], [{
    key: "parse",
    value: function parse(html, opts) {
      return new HtmlTableToJson(html, opts);
    }
  }]);
  return HtmlTableToJson;
}();
module.exports = HtmlTableToJson;